import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import StyledLink from '../Link';
export const FooterLinksItem = ({
  href = null,
  target = null,
  onClick = null,
  Link = undefined,
  linkProps = {},
  children
}) => {
  const {
    className,
    ...extraLinkProps
  } = linkProps;
  return /*#__PURE__*/React.createElement("li", {
    className: "footer-menu__item"
  }, /*#__PURE__*/React.createElement(StyledLink, _extends({
    className: cn('footer-menu__item__link', className),
    anchorComponent: Link
  }, extraLinkProps, {
    onClick,
    href,
    target
  }), children));
};
FooterLinksItem.propTypes = {
  href: PropTypes.string,
  target: PropTypes.string,
  onClick: PropTypes.func,
  children: PropTypes.node.isRequired,
  Link: PropTypes.elementType,
  // eslint-disable-next-line react/forbid-prop-types
  linkProps: PropTypes.object
};
export const FooterLinksTextItem = ({
  children
}) => /*#__PURE__*/React.createElement("li", {
  className: "footer-menu__item"
}, children);
FooterLinksTextItem.propTypes = {
  children: PropTypes.node.isRequired
};
//# sourceMappingURL=links-items.js.map